import FlowType2 from "./flowType2";

export {FlowType2};
export default FlowType2;
